import { capitalizeStr } from 'seller/utils/common';

export const getPreparedShopifyVariantDataFromApiData = data => {
  return data.map(item => {
    return {
      ...item,
      id: item.id,
      name: item.product_title,
      smallImage: item.img,
      marketplace: null,
      sku: item.sku || 'none',
      variation_value_one: item.variant,
      variation_type_one: 'variant',
      type: 'variation',
      salesChannelId: item.sales_channel,
      status: item.status && capitalizeStr(item.status),
      financial_status: item.financial_status && capitalizeStr(item.financial_status),
      order_fulfillment_status: item.order_fulfillment_status
        ? capitalizeStr(item.order_fulfillment_status)
        : 'Not available'
    };
  });
};
